export default {
  data() {
    return {
      ApproveLists: [],
    };
  },
  mounted() {
    this.ApproveLists = this.approveList;
  },
  methods: {
    operate(e) {
      this.$emit("Approve", e);
    },
  },
};
